import * as _ from "lodash";
import React, { FC } from "react";
import {
  ChipField,
  Datagrid,
  List,
  TextField,
  useTranslate,
} from "react-admin";
import AvatarField from "../components/AvatarField";
import DateTimeField from "../components/DateTimeField";
import ListActions from "./ListActions";
import ListFilter from "./ListFilters";
import { NotificationFilterName } from "./Create";
import { TextInput } from "react-admin";
import { CloneButton } from "react-admin";

const FilterTypeField: FC<any> = (props) => {
  // console.log(props);

  return (
    <span>{NotificationFilterName[_.get(props, "record.filterType")]}</span>
  );
};
const MajorList: FC<any> = (props) => {
  const translate = useTranslate();
  const postFilters = [<TextInput source="title" label="Search Title" />];
  return (
    <List
      {...props}
      title={translate("resources.posts.page.list")}
      actions={<ListActions />}
      filters={<ListFilter />}
    >
      <Datagrid optimized rowClick="edit">
        <TextField source="id" label="Id" />
        <AvatarField source="imageUrl" label="Ảnh" />
        <TextField source="status_vn" label="Trạng thái" />
        <TextField source="title" label="Tiêu đề" />
        <TextField source="send_type_vn" label="Loại thời gian gửi" />
        {/* <TextField source="type_vn" label="Loại thông báo" /> */}
        <DateTimeField source="created_at" label="Ngày tạo" />
        <CloneButton label="Copy" />
      </Datagrid>
    </List>
  );
};

export default MajorList;
